import { z } from 'zod';
export const company = z.object({
    id: z.string().uuid(),
    projectId: z.string().uuid(),
    name: z.string(),
    domain: z.string().nullable(),
    industry: z.string().nullable(),
    size: z.string().nullable(),
    street: z.string().nullable(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    region: z.string().nullable(),
    country: z.string().nullable(),
    addressFormatted: z.string().nullable(),
    websiteUrl: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    googlePlaceId: z.string().nullable(),
    googleMapsUrl: z.string().nullable(),
    googleProfileUrl: z.string().nullable(),
    rating: z.number().nullable(),
    ratingCount: z.number().int().nullable(),
    category: z.string().nullable(),
    openingHours: z.record(z.unknown()).nullable(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    ownerUserId: z.string().uuid().nullable(),
    custom: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createCompanyRequest = z.object({
    name: z.string().trim().min(1, 'Name fehlt').max(200),
    domain: z.string().max(200).optional().nullable(),
    industry: z.string().max(120).optional().nullable(),
    size: z.string().max(60).optional().nullable(),
    street: z.string().max(200).optional().nullable(),
    postalCode: z.string().max(30).optional().nullable(),
    city: z.string().max(120).optional().nullable(),
    region: z.string().max(120).optional().nullable(),
    country: z.string().max(2).optional().nullable(),
    addressFormatted: z.string().max(500).optional().nullable(),
    websiteUrl: z.string().max(500).optional().nullable(),
    phone: z.string().max(60).optional().nullable(),
    email: z.string().email().optional().nullable(),
    googlePlaceId: z.string().max(200).optional().nullable(),
    googleMapsUrl: z.string().max(500).optional().nullable(),
    googleProfileUrl: z.string().max(500).optional().nullable(),
    rating: z.number().min(1).max(5).optional().nullable(),
    ratingCount: z.number().int().min(0).optional().nullable(),
    category: z.string().max(120).optional().nullable(),
    openingHours: z.record(z.unknown()).optional().nullable(),
    ownerUserId: z.string().uuid().optional().nullable(),
    custom: z.record(z.unknown()).optional(),
});
export const updateCompanyRequest = createCompanyRequest.partial();
export const companyQuery = z.object({
    search: z.string().trim().max(200).optional(),
    city: z.string().trim().max(120).optional(),
    country: z.string().trim().max(2).optional(),
    sort: z.enum(['createdAt', 'name', 'rating']).default('createdAt'),
    direction: z.enum(['asc', 'desc']).default('desc'),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
export const companyPage = z.object({
    items: z.array(company),
    total: z.number().int(),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=companies.js.map